import { AppointmentPhase } from "components"
import ColorPicker, { ColorPickerSquare } from "components/ColorPicker"
import { AppointmentPhaseDropdown } from "components/dropdowns/reactselect/AppointmentPhaseDropdown"
import { DetailSectionTemplate } from "components/MainSectionTemplate/DetailSectionTemplate"
import { RenderEditOptions } from "components/MainSectionTemplate/types"
import RequiredTextInput from "components/ValidatedFields/RequiredTextInput"
import React, { useState } from "react"
import { getAppointmentPhase } from "utilities"
import { formatMainAreaItemWithCount } from "utilities/translationUtils"

interface StatusDetailSectionProps {
  status: server.dto.Status
  mainArea: server.dto.MainAreas
}

export const StatusDetailSection = (props: StatusDetailSectionProps) => {
  const { mainArea } = props;
  const [status, setStatus] = useState<server.dto.Status>(props.status);

  const onValueChanged = (key: string, value: any) => {
    if (key === "title") {
      setStatus({ ...status, title: value });
    } else if (key === "appointmentPhase") {
      setStatus({ ...status, appointmentPhase: value.value });
    } else if (key === "color") {
      setStatus({ ...status, hexColor: value });
    }
  }

  return <DetailSectionTemplate
    isInPageEditable
    onValueChanged={onValueChanged}
    sections={[{
      type: "regular",
      key: "status",
      title: RESX.Status.resxStatus,
      fields: [{
        key: "title",
        label: RESX.GeneralLabels.Title,
        render: () => <div>{status.title}</div>,
        inPageEdit: {
          render: ({ value, onChange, submit, cancel }: RenderEditOptions<string>) => <RequiredTextInput
            validatorKey="title"
            focusOnMount
            maxLength={serverReference.constants.status.maxTitleLength}
            value={value}
            onChange={(title) => { onChange(title); }}
            onEnter={() => submit()}
            onEsc={() => cancel()}
          />,
          fullWidth: true,
          type: "confirmOrCancelButton",
          initialValue: status.title,
          submitChange: (title: string) => window.CoreApi.Status.Update({
            appointmentPhase: status.appointmentPhase,
            title,
            hexColor: status.hexColor,
            statusId: status.statusId,
          }),
        },
      }, {
        key: "color",
        label: RESX.GeneralLabels.resxColor,
        render: () => <ColorPickerSquare value={status.hexColor} />,
        inPageEdit: {
          render: ({ value, onChange, submit }: RenderEditOptions<string>) => <div className="main-section-template-fields-padding">
            <ColorPicker
              startOpen
              onClose={() => submit()}
              value={value}
              onChange={(hexColor) => { onChange(hexColor); }}
            />
          </div>,
          fullWidth: true,
          disableClickOutside: true,
          type: "custom",
          initialValue: status.hexColor,
          submitChange: (hexColor: string) => window.CoreApi.Status.Update({
            appointmentPhase: status.appointmentPhase,
            title: status.title,
            hexColor,
            statusId: status.statusId,
          }),
        }
      }, {
        key: "appointmentPhase",
        label: RESX.Status.TreatAs,
        render: () => <AppointmentPhase value={status.appointmentPhase} displayLabel />,
        inPageEdit: {
          render: ({ value, onChange, cancel }: RenderEditOptions<server.dto.AppointmentPhase>) => <AppointmentPhaseDropdown
            value={value}
            onChange={(appointmentPhase) => {
              onChange(appointmentPhase, true);
            }}
            onEsc={() => cancel()}
            config={{
              focusOnMount: true,
              openMenuOnFocus: true,
            }}
          />,
          fullWidth: true,
          type: "custom",
          initialValue: getAppointmentPhase(status.appointmentPhase),
          submitChange: (appointmentPhase: server.dto.AppointmentPhase) => window.CoreApi.Status.Update({
            appointmentPhase: appointmentPhase.value,
            title: status.title,
            hexColor: status.hexColor,
            statusId: status.statusId,
          })
        },
        hidden: mainArea !== "show",
      }, {
        key: "withStatus",
        label: RESX.Status.WithStatus,
        render: () => <div>{formatMainAreaItemWithCount(status.itemsWithStatus, mainArea)}</div>,
      }, {
        key: "statusId",
        label: "SystemOne ID",
        render: () => <div>{status.statusId}</div>,
      }],
    }]}
  />
}